import { Button, makeStyles, Typography } from "@material-ui/core";
import { Directions } from "@material-ui/icons";
import React from "react";
import Logo from "../img/swift404.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    marginTop: "-70px",
    "&:before": {
      content: "''",
      position: "absolute",
      height: "100%",
      width: "100%",
      opacity: "6%",
      backgroundSize: "contain",
      backgroundImage: `url(${Logo})`,
    },
  },
  text: {
    color: "#938AF2",
    textDecoration: "underline",
    textDecorationColor: "#ffc911",
    textDecorationThickness: "2px",
  },
});

function NoPage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h2" className={classes.text}>
        Sorry, no page found here
      </Typography>
    </div>
  );
}

export default NoPage;
